import Vue from "vue";
import VueI18n from "vue-i18n";

import { getLocale } from "@/utils";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getLocale(), // set locale
  silentTranslationWarn: true,
  messages: {
    "en-us": require("@/i18n/en-us.json"),
    "zh-tw": require("@/i18n/zh-tw.json"),
    "zh-cn": require("@/i18n/zh-cn.json"),
    "vi-vn": require("@/i18n/vi-vn.json")
  } // set locale messages
});

export default i18n;
